import { api } from "../http"
import type { FacilityClassification, ModuleId } from "../../../config/moduleRegistry"

export type FacilityShiftTime = {
  id: string
  label: string
  startTime: string
  endTime: string
  notes?: string | null
}

export type FacilityCoordinates = {
  latitude?: number | null
  longitude?: number | null
}

export type FacilityModulesDto = {
  facilityId: string
  classification?: FacilityClassification | string | null
  modules: ModuleId[] | string[]
  province?: string | null
  district?: string | null
  coordinates?: FacilityCoordinates | null
  goLiveDate?: string | null
  trafficType?: string | null
  operatingHours?: string | null
  operationalNotes?: string | null
  shiftTimes?: FacilityShiftTime[] | null
  updatedAt?: string
  pendingAuthorization?: boolean
}

export type FacilityModuleUpdatePayload = {
  modules: ModuleId[]
  classification?: FacilityClassification | null
  province?: string | null
  district?: string | null
  coordinates?: FacilityCoordinates | null
  goLiveDate?: string | null
  trafficType?: string | null
  operatingHours?: string | null
  operationalNotes?: string | null
  shiftTimes?: FacilityShiftTime[] | null
}

function pathFor(facilityId: string) {
  return `/api/facilities/${encodeURIComponent(facilityId)}/modules`
}

export const facilityModulesApi = {
  async get(facilityId: string): Promise<FacilityModulesDto> {
    return api.get<FacilityModulesDto>(pathFor(facilityId))
  },
  async update(
    facilityId: string,
    payload: FacilityModuleUpdatePayload,
  ): Promise<FacilityModulesDto> {
    return api.put<FacilityModulesDto, FacilityModuleUpdatePayload>(pathFor(facilityId), payload)
  },
}
